<div class="box-off-canva" [ngClass]="{'open': this.openInfo}" (click)="closeOffCanvas()"></div>
<div class="offcanvas offcanvas-bottom" tabindex="-1" [ngClass]="{'show': this.openInfo}" style="height: fit-content; z-index: 120;" [ngStyle]="{'height': offCanvasHeight + 'px', 'z-index': 120}" #offCanva>
  <div class="header-info"tabindex="-1" [ngClass]="{'show': openInfo}"  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div></div>
  </div>
  <div class="offcanvas-body">
    <div class="content-offCanva">
        <span class="title-offCanva">Regras Cashback</span>
        <div class="rules-grid">

            <!-- Regras de acumulação -->
            <div class="rule-card accumulate">
                <div class="rule-icon-wrapper">
                    <i class="fa-solid fa-coins"></i>
                </div>
                <div class="rule-content">
                    <span class="rule-label">Para acumular</span>  
                    <ng-container *ngIf="this.company.configs.typeCashback == 2 || this.company.configs.typeCashback == 1;">
                        <p class="rule-desc" *ngIf="this.company.configs.typeValue == 1">
                            Ganhe {{ this.company.configs.value }}% de cashback em todos os seus pedidos.
                        </p>
                        <p class="rule-desc" *ngIf="this.company.configs.typeValue == 2">
                            Ganhe {{ this.company.configs.value | currency:'BRL' }} de cashback em todos os seus pedidos.
                        </p>
                    </ng-container>
                    <p class="rule-desc">Apenas pedidos finalizados são contabilizados.</p>
                </div>
            </div>

            <!-- Regras de uso -->
            <div class="rule-card use">
                <div class="rule-icon-wrapper">
                    <i class="fa-solid fa-receipt"></i>
                </div>
                <div class="rule-content">
                    <span class="rule-label">Para utilizar</span>



                    <ng-container *ngIf="this.company.configs.cashbackLimited == 1;">
                        <p class="rule-desc">
                            Você precisa acumular no mínimo {{ this.company.configs.cashbackLimitValue | currency:'BRL' }} de cashback para utilizar.
                        </p>
                    </ng-container>

                    <ng-container *ngIf="this.company.configs.cashbackLimited == 0;">
                        <p class="rule-desc">
                            O cashback pode ser utilizado a qualquer momento.
                        </p>
                    </ng-container>

                    <ng-container *ngIf="this.company.configs.cashbackMultiple == 1;">
                        <p class="rule-desc">
                            O cashback só pode ser utilizado em valores múltiplos de {{ this.company.configs.cashbackMultipleValue | currency:'BRL'}}.
                        </p>
                    </ng-container>

                </div>
            </div>
        </div>

        <!-- Data de expiração  -->
        <div class="rules-note">
            <i class="fa-solid fa-circle-info"></i>
            <p *ngIf="this.company.configs.cashbackExpiration > 0">O saldo de cashback expira em {{ this.company.configs.cashbackExpiration }} dias após a data de acumulação.</p>
            <p *ngIf="this.company.configs.cashbackExpiration == 0">O saldo de cashback não expira e pode ser utilizado em qualquer pedido na loja.</p>
        </div>
    </div>
    <div class="button-offCanva">
      <button (click)="closeOffCanvas()">Ok, Entendi</button>
    </div>
  </div>
</div>